var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FireIcon',{attrs:{"size":_vm.size ? _vm.size : '25',"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }